import React from 'react';
import { LocateIcon } from './icons';
import { locationHelp } from '../lib/platform';

/**
 * Hur man slår på platsåtkomst, för den plattform man faktiskt sitter på.
 *
 * Öppnas från felrutan i stället för att visas av sig själv — den som
 * medvetet sagt nej ska inte bli tillsagd varje gång appen startar.
 */
export default function LocationHelp({ onClose, onRetry, siteAllowed }) {
  const help = locationHelp(siteAllowed);

  return (
    <div className="sheet-overlay" onClick={onClose}>
      <div className="sheet" onClick={e => e.stopPropagation()}>
        <span className="sheet__icon"><LocateIcon size={28} /></span>
        <h2 className="sheet__title">{help.title}</h2>
        <p className="sheet__text">
          Utan platsåtkomst kan kartan inte visa var du är, och rutter kan inte
          räknas ut från din position.
        </p>

        <ol className="sheet__steps">
          {help.steps.map(step => <li key={step}>{step}</li>)}
        </ol>

        <button
          className="btn btn--primary btn--block"
          onClick={() => { onRetry(); onClose(); }}
        >
          Jag har gjort det — försök igen
        </button>
        <button className="btn btn--outline btn--block" onClick={onClose}>Stäng</button>
      </div>
    </div>
  );
}
